import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIEmptyState from 'UIComponents/empty/UIEmptyState';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { trackInsightsInteraction } from 'messaging-publishing-lib/utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function InsightsListFooter({
  data,
  fetchMore,
  fetchMoreLoading,
  fetchMoreError,
  fetchedMoreBefore
}) {
  if (!(data !== null && data !== void 0 && data.hasMore)) {
    return fetchedMoreBefore ? /*#__PURE__*/_jsx(UIEmptyState, {
      layout: "vertical",
      primaryContent: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "messaging-insights.insights.panel.footer.emptyState"
          })
        }), /*#__PURE__*/_jsx(UIIllustration, {
          name: "email-empty-state-low-performing",
          width: "35%"
        })]
      })
    }) : null;
  }
  if (fetchMoreError) {
    return /*#__PURE__*/_jsx(UIErrorMessage, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "messaging-insights.insights.panel.footer.error"
      })
    });
  }
  return /*#__PURE__*/_jsx(UILoadingButton, {
    loading: fetchMoreLoading,
    onClick: () => {
      trackInsightsInteraction({
        action: 'click-view-older-insights-button',
        insightsTab: (data === null || data === void 0 ? void 0 : data.sentiment) === 'POSITIVE' ? 'DOING_GOOD' : 'TO_IMPROVE'
      });
      void fetchMore();
    },
    use: "tertiary-extra-light",
    size: "extra-small",
    className: "center-block m-y-8",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "messaging-insights.insights.panel.footer.loadMore"
    })
  });
}
export default InsightsListFooter;